

function drawSubject(newSubject, type) {
	var subjects = [];
	for (var i = 0; i < newSubject.length; i++) {
		var html = '<li><a class="fl subject-img" href="/subject/page/id/' + newSubject[i].ky_subject_id + '">';
		html += '<img  src="/public/assets/images/svg/loading.svg" class="lazyload" data-src="' + newSubject[i].ky_subject_headimg + '" alt="' + newSubject[i].ky_subject_title + '"></a>';
		html += '<div class="subject-info"><h5>';
		html += '<a href="/subject/page/id/' + newSubject[i].ky_subject_id + '">' + newSubject[i].ky_subject_title + '</a>';
		html += '</h5>';
		html += '<p class="description">' + newSubject[i].ky_subject_content + '</p><p>';
		html += '<a class="blue-link" href="/subject/page/id/' + newSubject[i].ky_subject_id + '">'+newSubject[i].ky_article_num+'篇文章</a>';
		html += '<span class="tag"></span></p></div></li>';
		subjects.push(html);
	};
	if (type == 0) {
		$(".blog-subject-box ul").empty().html(subjects.join(""));
	} else {
		$(".blog-subject-box ul").append(subjects.join(""));
		$(".blog-article-more").removeClass("disabled").prop("disabled", false);
		$(".blog-article-more").html("点击查看更多");
	};
	$("body").lazyload();
	$(".loading-area").hide();
};

function getSubject(index, type) {
	var length = $(".blog-subject-box ul li").length;
	$.ajax({
		url: "/subject/getSubjectList",
		data: {
			index: index,
			num: length,
			type: type,
			pageSize: 15
		},
		beforeSend: function(xhr) {
			if (type == 1) {
				$(".blog-article-more").html('<span class="fa fa-pulse fa-spinner"></span> 拼命加载中');
				$(".blog-article-more").addClass("disabled").prop("disabled", true);
			} else {
				$(".blog-pagination").hide();
				$(".loading-area").show();
			}
		},
		success: function(data) {
			var result = eval('(' + data + ')');
			var newSubject = result.data;
			drawSubject(newSubject, type);
			if (result.hasMore == "0") {
				$(".blog-pagination").hide();
			} else {
				$(".blog-pagination").show();
			}
		},
		error: function(err) {}
	});
};
function SubjectPageInit(){
	getSubject();
};

$(function() {
	SubjectPageInit();
	$(".subject-tab a").on("click", function() {
		if (!$(this).hasClass("active")) {
			$(this).addClass("active").siblings().removeClass("active");
			getSubject($(this).index(), 0);
			$(".blog-article-more").attr("data-type-id", $(this).index());
		}
	});
	$(".blog-article-more").on("click", function() {
		var index = $(this).attr("data-type-id");
		getSubject(index, 1);
	});
	$(document).on("click",".follow",function(eun){
		if(users==""){
			$("input").val("");
			$(".ww_model").show();
			$(".ww_model_inner").addClass("bounceIn");
		}else{
			
		};
		e.stopPropagation();
	});
});